import { render, staticRenderFns } from "./DriverChat.vue?vue&type=template&id=0cb1ab1c&scoped=true&"
import script from "./DriverChat.vue?vue&type=script&lang=js&"
export * from "./DriverChat.vue?vue&type=script&lang=js&"
import style0 from "./DriverChat.vue?vue&type=style&index=0&id=0cb1ab1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1ab1c",
  null
  
)

export default component.exports